import axios from "../../../config/axiosConfig";
export const getProfile = async () => {
  const { data } = await axios.get("/api/auth/profile");
  return data?.user ?? data ?? null;
};
